import { Offer } from "@/types/airtable";

export interface SectionGroup {
  sectionName: string;
  offers: Offer[];
}

export function groupOffersBySections(offers: Offer[]): SectionGroup[] {
  const sectionMap = new Map<string, Offer[]>();
  
  offers.forEach(offer => {
    // If offer has no sections, put it in "Другое" (Other)
    const sections = offer.sections && offer.sections.length > 0 
      ? offer.sections 
      : ['Другое'];
    
    sections.forEach(section => {
      if (!sectionMap.has(section)) {
        sectionMap.set(section, []);
      }
      sectionMap.get(section)!.push(offer);
    });
  });
  
  // Convert map to array and sort sections alphabetically
  // Put "Другое" at the end
  const sortedSections = Array.from(sectionMap.entries())
    .map(([sectionName, offers]) => ({
      sectionName,
      offers: offers.sort((a, b) => new Date(b.createdTime).getTime() - new Date(a.createdTime).getTime())
    }))
    .sort((a, b) => {
      // Put "Другое" at the end
      if (a.sectionName === 'Другое') return 1;
      if (b.sectionName === 'Другое') return -1;
      return a.sectionName.localeCompare(b.sectionName, 'ru');
    });
    
  return sortedSections;
}